module.exports = __webpack_public_path__ + "media/images/mobile/solutions/9-f55a0316da31d97f4525dab6d11788ad.png";